import React from 'react';

import { Alert } from '@zillow/constellation';

import type { StatusType } from '@zillow/constellation';

import { StyledHeader } from './StyledComponents';

type Props = {
  title?: string | null;
  body: string | React.ReactNode;
  appearance: typeof StatusType;
};

const AlertWithTitle = ({ title, body, appearance }: Props) => (
  <Alert
    appearance={appearance}
    body={
      <>
        {title && <StyledHeader>{title}</StyledHeader>}
        <div>{body}</div>
      </>
    }
  />
);

export default AlertWithTitle;
